import React from 'react';
import { Box } from '@mui/material';
import CompanyProfile from '../components/About Us Page/CompanyProfile.tsx';
import Team from '../components/About Us Page/Team.tsx';
import Values from '../components/About Us Page/Values.tsx';
import WorkWithUs from '../components/About Us Page/WorkWithUs.tsx';
import './AboutUs.css';

// Fallback (PNG — keep if you need transparency)
import compPngFallback from '../images/CompProfile1.png';

// AVIF (alpha supported)
import comp256Avif from '../images/comp-256.avif';
import comp512Avif from '../images/comp-512.avif';
import comp1024Avif from '../images/comp-1024.avif';

// WebP (alpha supported)
import comp256Webp from '../images/comp-256.webp';
import comp512Webp from '../images/comp-512.webp';
import comp1024Webp from '../images/comp-1024.webp';

function AboutUs() {
  return (
    <Box className="about-us-page">
      <Box className="about-us-banner">
        <picture>
          <source
            type="image/avif"
            srcSet={`${comp256Avif} 256w, ${comp512Avif} 512w, ${comp1024Avif} 1024w`}
            sizes="100vw"
          />
          <source
            type="image/webp"
            srcSet={`${comp256Webp} 256w, ${comp512Webp} 512w, ${comp1024Webp} 1024w`}
            sizes="100vw"
          />
          {/* single PNG fallback only */}
          <img
            src={compPngFallback}
            alt="Banner"
            className="about-us-banner-image"
            sizes="100vw"
            loading="eager"
            fetchPriority="high"
            decoding="async"
            width={1024}
            height={1024}
          />
        </picture>
      </Box>

      <Box className="about-us-content">
        <CompanyProfile />
        <Team />
        <Values />
      </Box>
    </Box>
  );
}

export default AboutUs;

